module.exports = __webpack_public_path__ + "static/2.a95a3040.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/modeling/2.png
// module id = 882
// module chunks = 230667518368419 245178253630338